import React from 'react'
import images from '../../constants/images';
import './TwoColumn.css';

const TwoColumn = ({title, subtitleOne, subtitleTwo, paragraphOne, paragraphTwo }) => {
  return (
    <div className="app__twoColumn flex-center section__padding">
        <div className="app__twoColumn-content flex__center">
            <h1 className="headtext__roboto app__header-h1">{title}</h1>
        </div>
        <div className="app__twoColumn-content_body ">
            <div className="app__twoColumn-content_one">
                <h3 className="subheadtext__roboto">{ subtitleOne }</h3>
                <img src={ images.pitch } alt="pitch" className="pitch__img" />
                <p className="p__twoColumn">{paragraphOne }</p>
            </div>
            <div className="app__twoColumn-content_two">
                <h3 className="subheadtext__roboto">{ subtitleTwo }</h3>
                <img src={ images.pitch } alt="pitch" className="pitch__img" />
                <p className="p__twoColumn">{paragraphTwo}</p>
            </div>

        </div>


    </div>
  )
}

export default TwoColumn